import React from "react";
import { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

const WrapperWithTabs = ({
  tabBarOptions = [],
  commonProps = {},
  componentBasedProps = {},
  wrapperClassName = "",
  tabSelected,
  setTabSelected,
}) => {
  const [selectedTab, setSelectedTab] = useState(tabBarOptions[0]);
  const navigate = useNavigate()
  const {
    user: { userLabel },
    setCurrentTabSelect
  } = useAuth();
  const onTabSelect = (tab) => {
    setCurrentTabSelect(tab)
    if (setTabSelected) {
      setTabSelected(tab);
    } else {
      setSelectedTab(tab);
    }
  };

  const props = componentBasedProps?.[selectedTab?.id] || {};

  return (
    <div className={`tab-bar-wraper ${wrapperClassName}`}>
      <div className="flex gap-x-4">
        {tabBarOptions.map((item, index) => {
          if (item?.showTo && !item.showTo.includes(userLabel)) {
            return null;
          }
          return (
            <span
              className={`tab-option font-family-medium font-size-small ${
                (tabSelected || selectedTab)?.id === item?.id
                  ? "tab-option-active"
                  : ""
              }`}
              key={"tab-option-" + index}
              onClick={() => { 
                item?.isVoucher && navigate("/vouchers")
                return onTabSelect(item)
              }}
            >
              {item?.title}
            </span>
          );
        })}
      </div>
      <div className="component-wrapper">
        {(tabSelected || selectedTab).Component ? (
          tabSelected?.Component ? (
            <tabSelected.Component {...commonProps} {...props} />
          ) : (
            <selectedTab.Component {...commonProps} {...props} />
          )
        ) : null}
      </div>
    </div>
  );
};

export default WrapperWithTabs;
